export default __webpack_public_path__ + "static/media/panicbutton.a9b4f330.png";